import React, { useEffect, useState } from 'react';

import { PageHeader, Skeleton } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';

import { getChargingProfileDetail } from '../../hooks/profiles';
import ChargingProfileForm from '../organisms/ChargingProfile/ChargingProfileForm';

const ChargingProfileEditPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;

  h1 {
    font-size: 24px;
  }
`;

const ChargingProfileEditPage = () => {
  const { id } = useParams<any>();
  const [chargingProfile, setChargingProfile] = useState<any>({});
  const history = useHistory();
  useEffect(() => {
    (async function () {
      setChargingProfile(await getChargingProfileDetail(id));
    })();
  }, [id]);

  if (!Object.keys(chargingProfile).length)
    return (
      <ChargingProfileEditPageWrapper>
        <Skeleton active />
      </ChargingProfileEditPageWrapper>
    );

  if (chargingProfile?.type === 'error')
    return (
      <ChargingProfileEditPageWrapper>
        <p>Nenhum charging profile encontrado com este id.</p>
      </ChargingProfileEditPageWrapper>
    );

  const initialValues = {
    ...chargingProfile.form,
    schedulePeriodMap: chargingProfile?.form?.schedulePeriodMap?.length
      ? chargingProfile?.form?.schedulePeriodMap
      : [],
  };

  return (
    <ChargingProfileEditPageWrapper>
      <PageHeader
        className='site-page-header'
        onBack={() => history.goBack()}
        title='Editando perfil de recarga'
        subTitle={chargingProfile?.form?.description}
      />
      <ChargingProfileForm
        initialValues={initialValues}
        type='update'
        id={id}
      />
    </ChargingProfileEditPageWrapper>
  );
};

export default ChargingProfileEditPage;
